import React from 'react'
import Cookies from 'js-cookie'



/**
 * Ce composant représente une ligne de tableau(un enregistrement)
 * @returns RowTable
 */
export default function RowTable({data}) {


    const showDocName = (url_) => {
        const url = new URL(url_) 
        const paths = url.pathname.split('/')
        const filename = paths[paths.length - 1]
        return filename
    }

    function extractFileNameFromURL(url) {
        const urlParts = url.split('/');

        const fileName = urlParts[urlParts.length - 1];

        const cleanFileName = fileName.split('?')[0];

        return cleanFileName;
    }

    var getDateTime = function (timestamp) {
        var date = String(timestamp)

        var _date = date.split('T')[0]
        var _time = date.split('T')[1].split('.')[0]

        return _date + ' ' + _time
    }

    const user = JSON.parse(Cookies.get('user'))

    var entreprise = user.entreprise ? user.entreprise.raison_sociale : null

    return (
            <tr>
                <td>
                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                        <input className="form-check-input" type="checkbox" value="1" />
                    </div>
                </td>
                                                
                <td>
                    <div className="d-flex align-items-center">
                        <a href="edit-product.html" className="symbol symbol-50px">
                            <img src="https://thumbs.dreamstime.com/b/documents-ou-contrat-de-bureau-sur-un-fond-bleu-136090443.jpg" className="" alt="" />
                        </a>
                        <div className="ms-5">
                            <a href="edit-product.html" className="text-gray-800 text-hover-primary fs-5 fw-bolder" data-kt-ecommerce-product-filter="product_name">{showDocName(data.document)}</a>
                        </div>
                    </div>
                </td>
                                                                                   
                <td className="text-end pe-0">
                    <span className="fw-bolder text-dark">
                        { data.statut === 'en_attente' ? getDateTime(data.created_at) : getDateTime(data.updated_at) }
                    </span>
                </td>
                                                
                <td className="text-end pe-0" data-order="Published">
                    {data.statut === "en_attente" && <span className="badge en_attente-btn">En attente...</span> } 
                    {data.statut === "en_cours" && <span className="badge en_cour-btn">En cours...</span> } 
                    {data.statut === "signe" && <span className="badge signer-btn">Signé</span> }
                    {data.statut === "refuse" && <span className="badge refuse-btn">Refusé</span> }
                </td>
                                                
                <td className="text-end">
                    <a href={`${entreprise === 'ANRMP' ? `https://www.dkbsigns.com/API3/Api_dkbsign3/include/DOCSIGN_ARNMP/${extractFileNameFromURL(data.document)}` : data.document}`}
                    className="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Voir</a>		
                </td>				
            </tr>
    )
}
